<template>
  <div id="user-space-layer">
    <light-header></light-header>
    <div class="user-space-content auto">
      <div class="user-space-info">
        <div class="left">
          <div class="left-top">
            <img v-if="userScope.spaceType === 'company'" src="../../assets/images/auth-company.png" class="user-img"
              alt="" />
            <img v-if="userScope.spaceType === 'person'" src="../../assets/images/auth-person.png" class="user-img"
              alt="" />
            <span class="user-name">{{ userScope.spaceName }}</span>
            <img class="user-auth" :src="
              userScope.isAuthed == 'passAuth' ? authIcons[0] : authIcons[1]
            " alt="" />
          </div>

          <div class="left-bottom" v-if="userScope.spaceType === 'company'">
            <div>
              <span>企业管理员</span>
              <span class="value">{{ userScope.companyAdmin }}</span>
            </div>
            <div>
              <span>企业成员</span>
              <span class="value">{{ userScope.companyMemberCount }}人</span>
            </div>
          </div>

          <div class="person-left-bottom" v-if="userScope.spaceType === 'person'">
            <div>
              <span>身份证号</span>
              <span class="value">{{ userScope.idNo }}</span>
            </div>
            <div>
              <span>手机号</span>
              <span class="value">{{ userScope.phone }}</span>
            </div>
          </div>
        </div>
        <div class="mid">
          <div class="mid-item">
            <div class="count">{{ userScope.total }}份</div>
            <div>
              套餐总量
              <el-button v-if="userScope.isSpaceOwner === 'yes'" type="text" style="padding: 0" @click="handleCart">去购买>
              </el-button>
            </div>
          </div>
          <div class="mid-item">
            <div class="count">{{ userScope.surplus }}份</div>
            <div>当前剩余合同发起数量</div>
          </div>
        </div>
        <div class="right">
          <a href="javascript:;" class="to-sign" @click="toFlow">发起签约+</a>
          <a :href="toConsole()" target="_blank" class="to-console" v-if="userScope.spaceType === 'company'">企业控制台</a>
        </div>

        <!-- <p class="card clearfix">
					<span>身份证号</span>
					<span>{{idCard}}</span>
				</p>
				<p class="phone clearfix">
					<span>手机号</span>
					<span>{{phone}}</span>
				</p> -->
        <!-- <div class="company-meal">
          <p>10份</p>
          <p>企业套餐容量</p>
        </div>
        <div class="user-meal">
          <p>10份</p>
          <p>当前剩余合同发起数量</p>
        </div> -->
        <!-- <el-button type="primary" class="to-sign" @click="toFlow" style="background: #409eff; border-color: #409eff; color: white;">
          发起签约+</el-button> -->
      </div>

      <div class="user-menu-content auto">
        <div class="user-menu">
          <el-menu :default-active="onRoutes" router class="el-menu-vertical" @open="handleOpen" @close="handleClose"
            @select="handleSelect" :unique-opened="true">
            <el-submenu index="/user-space">
              <template slot="title">
                <span class="fitst-menu">合同管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user-space/contracts?status=all">
                  <template>
                    <span class="menu-text" style="margin-left: 0">全部</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=waitSend">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/waitSend2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/waitSend1-icon.png" alt="" />
                    <span class="menu-text">待发送</span>
                    <span class="menu-num">{{
                      userContractInfo.waitSend
                    }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=iSign">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/my2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/my1-icon.png" alt="" />
                    <span class="menu-text">待我签署</span>
                    <span class="menu-num">{{ userContractInfo.iSign }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=process" v-if="userScope.spaceType === 'company'">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/inApproval2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/inApproval1-icon.png" alt="" />
                    <span class="menu-text">审批中</span>
                    <span class="menu-num">{{ userContractInfo.process }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=otherSign">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/sign2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/sign1-icon.png" alt="" />
                    <span class="menu-text">待他签署</span>
                    <span class="menu-num">{{
                      userContractInfo.otherSign
                    }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=finish">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/complete2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/complete1-icon.png" alt="" />
                    <span class="menu-text">签署完成</span>
                    <span class="menu-num">{{ userContractInfo.finish }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=expire">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/timeout2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/timeout1-icon.png" alt="" />
                    <span class="menu-text">已过期</span>
                    <span class="menu-num">{{ userContractInfo.expire }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=recall">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/recalled2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/recalled1-icon.png" alt="" />
                    <span class="menu-text">已撤回</span>
                    <span class="menu-num">{{ userContractInfo.recall }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=reject">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/returnd2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/returnd1-icon.png" alt="" />
                    <span class="menu-text">拒签</span>
                    <span class="menu-num">{{ userContractInfo.reject }}</span>
                  </template>
                </el-menu-item>
                <!-- <el-menu-item index="/user-space/contracts?status=returnd">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/return2-icon.png" alt="">
                    <img width="15" class="img2" src="../../assets/images/index/return1-icon.png" alt="">
                    <span class="menu-text">被退回</span>
                    <span class="menu-num">{{userContractInfo.returnd}}</span>
                  </template>
                </el-menu-item> -->
                <el-menu-item index="/user-space/contracts?status=cancel">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/return2-icon.png" alt="">
                    <img width="15" class="img2" src="../../assets/images/index/return1-icon.png" alt="">
                    <span class="menu-text">已作废</span>
                    <span class="menu-num">{{ userContractInfo.cancel }}</span>
                  </template>
                </el-menu-item>
                <el-menu-item index="/user-space/contracts?status=draft">
                  <template>
                    <img width="20" class="img1" src="../../assets/images/index/draft2-icon.png" alt="" />
                    <img width="15" class="img2" src="../../assets/images/index/draft1-icon.png" alt="" />
                    <span class="menu-text">草稿箱</span>
                    <span class="menu-num">{{ userContractInfo.draft }}</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="/approve"
              v-if="$store.state.userInfo.userType == 'person' && $store.state.currentSpace.space.spaceType == 'company'">
              <template slot="title">
                <span class="fitst-menu">审批管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/approve/list?status=mylauch">
                  <template>
                    <span class="menu-text" style="margin-left: 0">我发起的</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/approve/list?status=myapproval">
                  <template>
                    <span class="menu-text" style="margin-left: 0">我审批的</span>
                  </template>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-menu-item index="/user-space/signatures" class="parent"
              v-if="userInfo.userType === 'company' || (userInfo.userType === 'person' && userScope.spaceType === 'person')">
              <span class="fitst-menu" slot="title">签章管理</span>
            </el-menu-item>
            <!-- <el-menu-item index="3" class="parent">
              <span class="fitst-menu" slot="title">费用管理</span>
            </el-menu-item> -->
          </el-menu>
        </div>

        <div class="user-main">
          <router-view :space="userScope.spaceType"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lightHeader from "./../../components/lightHeader";
import { getUserInfoApi } from "@/api/home";
import { contractCountApi } from "@/api/space/contracts";
import { getSpaceDetailInfo } from "@/api/home";
import { mapState } from "vuex";
export default {
  components: {
    lightHeader,
  },
  data() {
    return {
      userScope: {},
      authIcons: [
        require("../../assets/images/authed.png"),
        require("../../assets/images/not-auth.png"),
      ],
      authUserHeaderImgs: [
        require("../../assets/images/index/user1-icon.png"),
        require("../../assets/images/index/user2-icon.png"),
      ],
    };
  },
  computed: {
    onRoutes() {
      let path;
      if (this.$route.query.status) {
        path = this.$route.path + "?status=" + this.$route.query.status;
      } else {
        path = this.$route.path;
      }
      return path;
    },
    idCard() {
      var str1 = "";
      if (this.userInfo.idCard) {
        str1 = this.userInfo.idCard.replace(
          /(\d{1})(\d+)(\d{1})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );

        return str1;
      }
    },
    phone() {
      var str1 = "";
      if (this.userInfo.phone) {
        str1 = this.userInfo.phone.replace(
          /(\d{3})(\d+)(\d{4})/,
          function (x, y, z, p) {
            var i = "";
            while (i.length < z.length) {
              i += "*";
            }
            return y + i + p;
          }
        );

        return str1;
      }
    },
    ...mapState(["userInfo", "userContractInfo"]),
  },
  mounted() {
    this.handleGetSpaceDetailInfo();
    this.getContractCount();
    this.$bus.$on("emitSpaceChange", (data) => {
      this.handleGetSpaceDetailInfo();
      this.getContractCount();
    });
  },
  beforeDestroy() {
    //销毁监听事件
    this.$bus.$off("emitSpaceChange");
  },
  methods: {
    handleCart() {
      this.$router.push({
        path: "/cart/cart",
      });
    },
    handleGetSpaceDetailInfo() {
      getSpaceDetailInfo().then((res) => {
        if (res.code === 200) {
          this.userScope = res.data;
        }
      });
    },
    getContractCount() {
      contractCountApi()
        .then((res) => {
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$store.commit("SET_USER_CONTRSCT_INFO", res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      // this.getUserInfoHandle()
    },
    toFlow() {
      this.$router.push({
        path: "/temp-create",
        query: {
          from: this.$route.fullPath.replace(/\?/, "!!"),
        },
      });
    },
    toConsole() {
      const consoleHref = ((process.env.NODE_ENV == "production" && GLOBAL_CONFIG && GLOBAL_CONFIG.APP_CONSOLE_URL) ? GLOBAL_CONFIG.APP_CONSOLE_URL : process.env.VUE_APP_CONSOLE_URL);
      return consoleHref;
    },
  },
};
</script>

<style></style>

<style lang="scss" scoped>
#user-space-layer {
  background: #f0f0f5;
}

.user-space-content {
  /* width: 1200px;
																																	margin: 30px auto 0; */
  margin-top: 30px;
}

.user-space-info {
  width: 100%;
  height: 164px;
  background: rgba(255, 255, 255, 1);
  padding: 28px 79px 28px 29px;
  // box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    .left-top {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 18px;

      .user-img {
        width: 51px;
        height: 51px;
        margin-right: 16px;
      }

      .user-name {
        margin-right: 12px;
      }

      .user-auth {
        width: 48px;
        height: auto;
        margin-top: 2px;
      }
    }

    .left-bottom {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 16px;
      padding-left: 67px;
      padding-bottom: 15px;
      color: #999999;

      &>div {
        margin-right: 22px;
      }

      .value {
        font-weight: bold;
        color: #333333;
        margin-left: 15px;
      }
    }

    .person-left-bottom {
      font-size: 16px;
      color: #999999;
      padding-left: 67px;

      &>div {
        margin-right: 22px;
        margin-top: 10px;
      }

      .value {
        font-weight: bold;
        color: #333333;
        margin-left: 15px;
      }
    }
  }

  .mid {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding-bottom: 15px;

    .mid-item {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #999999;

      .count {
        font-weight: bold;
        color: #333333;
        font-size: 21px;
        margin-bottom: 14px;
      }
    }

    .mid-item+.mid-item {
      margin-left: 67px;
    }
  }

  .right {
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .to-sign {
      width: 100px;
      height: 32px;
      background: linear-gradient(0deg,
          rgba(59, 178, 253, 1) 0%,
          rgba(15, 217, 242, 1) 99%);
      // box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.17);
      border-radius: 10px;
      text-align: center;
      display: block;
      line-height: 32px;
      color: #ffffff;
      font-size: 14px;
    }

    .to-console {
      margin-top: 30px;
      width: 100px;
      height: 32px;
      background: #ff6633;
      // box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.17);
      border-radius: 8px;
      color: #fff;
      text-align: center;
      border-radius: 10px;
      display: block;
      line-height: 32px;
      font-size: 14px;
    }
  }
}

.user-space-info .card {
  position: absolute;
  left: 99px;
  top: 78px;
  width: 700px;
}

.user-space-info .phone {
  position: absolute;
  left: 99px;
  top: 117px;
  width: 700px;
}

.user-space-info .card,
.user-space-info .phone {
  font-size: 16px;
  line-height: 16px;
}

.user-space-info .card span:nth-of-type(1),
.user-space-info .phone span:nth-of-type(1) {
  color: #999999;
  width: 65px;
  float: left;
}

.user-space-info .card span:nth-of-type(2),
.user-space-info .phone span:nth-of-type(2) {
  color: #333333;
  margin-left: 25px;
}

.company-meal {
  position: absolute;
  left: 528px;
  top: 64px;
  width: 100px;
  text-align: center;
}

.company-meal p:first-child,
.user-meal p:first-child {
  font-size: 26px;
  color: #333333;
  font-weight: 600;
}

.company-meal p:last-child,
.user-meal p:last-child {
  font-size: 16px;
  color: #999999;
}

.user-meal {
  position: absolute;
  left: 691px;
  top: 64px;
  text-align: center;
  width: 160px;
}

.user-menu-content {
  /* width: 1200px;
																																											    margin: 22px auto 0; */
  margin-top: 22px;
  display: flex;
  justify-content: space-between;
}

.user-menu {
  width: 230px;
  min-height: calc(100vh - 287px);
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.13);
}

.user-main {
  width: 948px;
  min-height: calc(100vh - 287px);
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 2px 12px 1px rgba(0, 0, 0, 0.08);
}

.menu-text {
  font-size: 14px;
  margin-left: 10px;
  // color: #999999;
}

.menu-num {
  font-size: 14px;
  margin-left: 10px;
  // color: #999999;
}

.fitst-menu {
  font-size: 16px;
}

.img1 {
  display: none;
  margin-left: -5px;
}

// .el-menu-item:hover,
// .el-menu-item:focus {
// 	background: #ffffff;
// }

// .el-menu-item:hover .menu-text,
// .el-menu-item:focus .menu-text {
// 	color: #333333;
// }

// .el-menu-item:focus .menu-num,
// .el-menu-item:hover .menu-num {
// 	color: #276ee8;
// }

.el-menu-item:hover .img1,
.el-menu-item:focus .img1,
.el-menu-item:active .img1,
.el-menu-item:visited .img1 {
  display: inline-block;
}

.el-menu-item:hover .img2,
.el-menu-item:focus .img2,
.el-menu-item:active .img2,
.el-menu-item:visited .img2 {
  display: none;
}

/deep/ .el-submenu__title:hover {
  background: unset;
}

// .is-active .el-menu-item {
// 	background: #ffffff;
// 	border: none;
// }

// .is-active .is-active .menu-text {
// 	color: #333333;
// }

.is-active .is-active .img1 {
  display: inline-block;
}

.is-active .is-active .img2 {
  display: none;
}

.el-menu-item.is-active {
  color: #3296fa;
  background-color: #ebf5ffaa;
}

.el-submenu .el-menu-item {
  // margin: 10px 15px;
  height: 45px;
  line-height: 45px;
}

/deep/ .el-menu-item-group__title {
  display: none;
}

.el-menu-vertical {
  position: sticky;
  left: 0;
  top: 0;
}
</style>
